import { useNavigate } from 'react-router-dom';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';
import { useEffect } from 'react';
import Step2SelectItems from '@modules/Steps/Components/Step2SelectItems/Step2SelectItems';
import { ROUTES } from '@configs/AppRoutes';

const Step2SelectItemsPage = () => {
    const [isDesktop] = useMediaType();
    const navigate = useNavigate();

    useEffect(() => {
        if (isDesktop) {
            navigate(ROUTES.BOM);
        }
    }, [isDesktop]);

    return <Step2SelectItems />;
};

export default Step2SelectItemsPage;
